import React from "react";

const SpecializationIcon = ({
  onClickFn = () => {},
  width = "25",
  height = "20",
  fill = "currentColor",
}) => {
  return (
    <svg
      className="cursor-pointer"
      onClick={onClickFn}
      width={width}
      height={height}
      viewBox="0 0 25 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3246_133)">
<path d="M10 2.5H15V5H10V2.5ZM9.375 0C8.33984 0 7.5 0.839844 7.5 1.875V5.625C7.5 6.66016 8.33984 7.5 9.375 7.5H11.25V8.75H1.25C0.558594 8.75 0 9.30859 0 10C0 10.6914 0.558594 11.25 1.25 11.25H5V12.5H3.125C2.08984 12.5 1.25 13.3398 1.25 14.375V18.125C1.25 19.1602 2.08984 20 3.125 20H9.375C10.4102 20 11.25 19.1602 11.25 18.125V14.375C11.25 13.3398 10.4102 12.5 9.375 12.5H7.5V11.25H17.5V12.5H15.625C14.5898 12.5 13.75 13.3398 13.75 14.375V18.125C13.75 19.1602 14.5898 20 15.625 20H21.875C22.9102 20 23.75 19.1602 23.75 18.125V14.375C23.75 13.3398 22.9102 12.5 21.875 12.5H20V11.25H23.75C24.4414 11.25 25 10.6914 25 10C25 9.30859 24.4414 8.75 23.75 8.75H13.75V7.5H15.625C16.6602 7.5 17.5 6.66016 17.5 5.625V1.875C17.5 0.839844 16.6602 0 15.625 0H9.375ZM3.75 17.5V15H8.75V17.5H3.75ZM16.25 15H21.25V17.5H16.25V15Z" fill={fill}/>
</g>
<defs>
<clipPath id="clip0_3246_133">
<path d="M0 0H25V20H0V0Z" fill={fill}/>
</clipPath>
</defs>
    </svg>
  );
};

export default SpecializationIcon;
